import { render, staticRenderFns } from "./Reception.vue?vue&type=template&id=656cc7d3&scoped=true&"
import script from "./Reception.vue?vue&type=script&lang=js&"
export * from "./Reception.vue?vue&type=script&lang=js&"
import style0 from "./Reception.vue?vue&type=style&index=0&id=656cc7d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656cc7d3",
  null
  
)

export default component.exports